module.exports = __webpack_public_path__ + "images/internal/datashake/icons/yelp.svg";